import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
import api from '../../Services/api';


import { COLORS } from '../colors';
import {

  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,

} from '@mui/material';

import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend
} from 'chart.js';

// Register necessary components for Chart.js
ChartJS.register(ArcElement, Tooltip, Legend);

const months = [
  { name: "JANUARY", value: "01" },
  { name: "FEBRUARY", value: "02" },
  { name: "MARCH", value: "03" },
  { name: "APRIL", value: "04" },
  { name: "MAY", value: "05" },
  { name: "JUNE", value: "06" },
  { name: "JULY", value: "07" },
  { name: "AUGUST", value: "08" },
  { name: "SEPTEMBER", value: "09" },
  { name: "OCTOBER", value: "10" },
  { name: "NOVEMBER", value: "11" },
  { name: "DECEMBER", value: "12" }
];
const currentYear = new Date().getFullYear();
const years = Array.from({ length: currentYear - 2020 + 1 }, (x, i) => 2020 + i);
const statesInIndia = ['Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh', 'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand', 'Karnataka', 'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur', 'Meghalaya', 'Mizoram', 'Nagaland', 'Odisha', 'Punjab', 'Rajasthan', 'Sikkim', 'Tamil Nadu', 'Telangana', 'Tripura', 'Uttar Pradesh', 'Uttarakhand', 'West Bengal', 'Andaman and Nicobar Islands', 'Chandigarh', 'Dadra and Nagar Haveli and Daman and Diu', 'Delhi', 'Ladakh', 'Lakshadweep', 'Puducherry'];

export const EstablishmentMonthlydataCreatePage = () => {
  let data = sessionStorage.getItem('user');
  let assessorData = JSON.parse(data);
  let id = assessorData.id;

  const [establishment, setEstablishment] = useState([]);
  const [companyId, setCompanyId] = useState('')
  const [establishmentChartData, setestablishmentChartData] = useState({});
  const [selectedValues, setSelectedValues] = useState({});
  const [selectYearForMasterData, setSelectYearForMasterData] = useState('');
  const [selectedMonth, setSelectedMonth] = useState('');
const[division,setDivision] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [errorSnackbarOpen, setErrorSnackbarOpen] = useState(false);
  const [snackbarErrorMessage, setSnackbarErrorMessage] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {

    fetchEstablishmentData();

  }, [id]);

  const fetchEstablishmentData = async () => {
    try {

      const response = await api.assessor.getEstablishment(id);
      if (response.status === 200) {
        const id = response.data.Establishment.companyId
        const division = response.data.Establishment.division
        setEstablishment(response.data.Establishment);
        setCompanyId(id)
        setDivision(division)
        setLoading(false);
        if (companyId) {
          masterData(companyId)
        }
      }
      else if (response.status === 400) {
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage(response.data.message);
        setEstablishment([])
        setLoading(false);
      }
      else if (response.status === 404) {
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage(response.data.message);
        setEstablishment([])
        setLoading(false);
      }
      else if (response.status === 500) {
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage(response.data.message);
        setEstablishment([])
        setLoading(false);
      }
      else {
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage("Some error occured, please try again")
        setEstablishment([])
        setLoading(false);
      }



    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    if (companyId) {
      masterData(companyId)
    }
  }, [companyId])






  const handleYearChangeForMasterData = (event) => {
    const year = event.target.value;
    setSelectYearForMasterData(year);



  };

  const masterData = async (establishmentId) => {
    try {

      const response = await api.client.getClientMasterData(establishmentId);
      if (response.status === 200) {
        const chartData = response.data.data; // assuming this has the necessary data
        setestablishmentChartData(chartData)
      }
      else if (response.status === 400) {
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage(response.data.message)
      }
      else if (response.status === 404) {
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage(response.data.message)
      }
      else if (response.status === 500) {
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage(response.data.message)
      }
    } catch (error) {
      console.error("Error fetching establishment details:", error);
    }
  };















  const handleMonthlyData = async (companyId, corporateId, selectedMonth, selectYearForMasterData) => {
    if (!selectedMonth || !selectYearForMasterData) {
      setErrorSnackbarOpen(true);
      setSnackbarErrorMessage("Please select month and year");
      return;
    }
    else {
      const Monthlydata = {
        companyId: companyId,
        CorporateId: corporateId,
        month: selectedMonth,
        year: selectYearForMasterData,
        division:division,
        complianceFiledDate: '',

        AcceptedPercent: 0,
        RejectedPercent: 0,
        UnderReviewPercent: 0,
        complied: "",
        nonComplied: "",
        TheGoodsAndServiceTaxOutwardSupplies: {
          na: false,
          fileUrl: '',
          validation: 0,
          AssessorRemark: '',
          clientRemark: '',
          frequency: '',
          DueDate: '',
          qId: 0,

        },
         TheGoodsAndServiceTaxSummaryReturn: {
          na: false,
          fileUrl: '',
          validation: 0,
          AssessorRemark: '',
          clientRemark: '',
          frequency: '',
          DueDate: '',
          qId: 1,

        },
         FactoryHalfYearReturn: {
          na: false,
          fileUrl: '',
          validation: 0,
          AssessorRemark: '',
          clientRemark: '',
          frequency: '',
          DueDate: '',
          qId: 2,

        },
         FactoryAnnualReturns: {
          na: false,
          fileUrl: '',
          validation: 0,
          AssessorRemark: '',
          clientRemark: '',
          frequency: '',
          DueDate: '',
          qId: 3,

        },
         FireSafetyTraining: {
          na: false,
          fileUrl: '',
          validation: 0,
          AssessorRemark: '',
          clientRemark: '',
          frequency: '',
          DueDate: '',
          qId: 4,

        },
         EnvironmentalAuditReport: {
          na: false,
          fileUrl: '',
          validation: 0,
          AssessorRemark: '',
          clientRemark: '',
          frequency: '',
          DueDate: '',
          qId: 5,

        },
         DirectGreenhouseGasGHGEmissions: {
          na: false,
          fileUrl: '',
          validation: 0,
          AssessorRemark: '',
          clientRemark: '',
          frequency: '',
          DueDate: '',
          qId: 6,

        },
         IndirectGHGEmissions: {
          na: false,
          fileUrl: '',
          validation: 0,
          AssessorRemark: '',
          clientRemark: '',
          frequency: '',
          DueDate: '',
          qId: 7,

        },
         AllOtherIndirectEmissionsInTheValueChain: {
          na: false,
          fileUrl: '',
          validation: 0,
          AssessorRemark: '',
          clientRemark: '',
          frequency: '',
          DueDate: '',
          qId: 8,

        },
         TotalEnergyConsumedRenewableSources: {
          na: false,
          fileUrl: '',
          validation: 0,
          AssessorRemark: '',
          clientRemark: '',
          frequency: '',
          DueDate: '',
          qId: 9,

        },


        TotalEnergyConsumedNonRenewableSources: {
          na: false,
          fileUrl: '',
          validation: 0,
          AssessorRemark: '',
          clientRemark: '',
          frequency: '',
          DueDate: '',
          qId: 10,

        },
        WaterConsumed: {
          na: false,
          fileUrl: '',
          validation: 0,
          AssessorRemark: '',
          clientRemark: '',
          frequency: '',
          DueDate: '',
          qId: 11,

        },
        
        TotalAmountOfwasteGenerated: {
          na: false,
          fileUrl: '',
          validation: 0,
          AssessorRemark: '',
          clientRemark: '',
          frequency: '',
          DueDate: '',
          qId: 12,

        },
        CapExOnGreenInitiatives: {
          na: false,
          fileUrl: '',
          validation: 0,
          AssessorRemark: '',
          clientRemark: '',
          frequency: '',
          DueDate: '',
          qId: 13,

        },
         PenaltiesAndFinesPaidDueToEnvironmentalIssues: {
          na: false,
          fileUrl: '',
          validation: 0,
          AssessorRemark: '',
          clientRemark: '',
          frequency: '',
          DueDate: '',
          qId: 14,

        },
        OpexOnGreenInitiatives: {
          na: false,
          fileUrl: '',
          validation: 0,
          AssessorRemark: '',
          clientRemark: '',
          frequency: '',
          DueDate: '',
          qId: 15,

        },
        CSRBudgetAsAPercentOfProfits: {
          na: false,
          fileUrl: '',
          validation: 0,
          AssessorRemark: '',
          clientRemark: '',
          frequency: '',
          DueDate: '',
          qId: 16,

        },
        PercentOfCSRBudgetUtilized: {
          na: false,
          fileUrl: '',
          validation: 0,
          AssessorRemark: '',
          clientRemark: '',
          frequency: '',
          DueDate: '',
          qId: 17,

        },
        HazardousWasteAnnualReturns: {
          na: false,
          fileUrl: '',
          validation: 0,
          AssessorRemark: '',
          clientRemark: '',
          frequency: '',
          DueDate: '',
          qId: 18,

        },
 PressureVesselReport: {
          na: false,
          fileUrl: '',
          validation: 0,
          AssessorRemark: '',
          clientRemark: '',
          frequency: '',
          DueDate: '',
          qId: 19,

        },
         EpfoEcrAndRemittanceConfirmationChallan: {
          na: false,
          fileUrl: '',
          validation: 0,
          AssessorRemark: '',
          clientRemark: '',
          frequency: '',
          DueDate: '',
          qId: 20,

        },
         EpfoPaidChallanCopyAndDate: {
          na: false,
          fileUrl: '',
          validation: 0,
          AssessorRemark: '',
          clientRemark: '',
          frequency: '',
          DueDate: '',
          qId: 21,

        },
           EpfoCopyOfReturnToInternationalWorkers: {
          na: false,
          fileUrl: '',
          validation: 0,
          AssessorRemark: '',
          clientRemark: '',
          frequency: '',
          DueDate: '',
          qId: 22,

        },
           EsicMonthlyContributionHistoryAndChallans: {
          na: false,
          fileUrl: '',
          validation: 0,
          AssessorRemark: '',
          clientRemark: '',
          frequency: '',
          DueDate: '',
          qId: 23,

        },
           EsicHalfYearlyReturnsMaintainHalfYearlyReturn: {
          na: false,
          fileUrl: '',
          validation: 0,
          AssessorRemark: '',
          clientRemark: '',
          frequency: '',
          DueDate: '',
          qId: 24,

        },
           TaxOnProfessions: {
          na: false,
          fileUrl: '',
          validation: 0,
          AssessorRemark: '',
          clientRemark: '',
          frequency: '',
          DueDate: '',
          qId: 25,

        },
           LabourWelfareFund: {
          na: false,
          fileUrl: '',
          validation: 0,
          AssessorRemark: '',
          clientRemark: '',
          frequency: '',
          DueDate: '',
          qId: 26,

        },
           LabourWelfareFundFormD: {
          na: false,
          fileUrl: '',
          validation: 0,
          AssessorRemark: '',
          clientRemark: '',
          frequency: '',
          DueDate: '',
          qId: 27,

        },
           ClraRcAnnualReturns: {
          na: false,
          fileUrl: '',
          validation: 0,
          AssessorRemark: '',
          clientRemark: '',
          frequency: '',
          DueDate: '',
          qId: 28,

        },
              PaymentOfBonusActReturnAnnexure: {
          na: false,
          fileUrl: '',
          validation: 0,
          AssessorRemark: '',
          clientRemark: '',
          frequency: '',
          DueDate: '',
          qId: 29,

        },
        PaymentOfBonusActReturnAcknowledgmentCopy: {
          na: false,
          fileUrl: '',
          validation: 0,
          AssessorRemark: '',
          clientRemark: '',
          frequency: '',
          DueDate: '',
          qId: 30,

        },
              EmployeeTurnoverRate: {
          na: false,
          fileUrl: '',
          validation: 0,
          AssessorRemark: '',
          clientRemark: '',
          frequency: '',
          DueDate: '',
          qId: 31,

        },
              AverageHoursOfTrainingPerEmployee: {
          na: false,
          fileUrl: '',
          validation: 0,
          AssessorRemark: '',
          clientRemark: '',
          frequency: '',
          DueDate: '',
          qId: 32,

        },
              GenderPayGap: {
          na: false,
          fileUrl: '',
          validation: 0,
          AssessorRemark: '',
          clientRemark: '',
          frequency: '',
          DueDate: '',
          qId: 33,

        },
           WorkforceDemographics: {
          na: false,
          fileUrl: '',
          validation: 0,
          AssessorRemark: '',
          clientRemark: '',
          frequency: '',
          DueDate: '',
          qId: 34,

        },
           PercentageOfIndependentDirectorsOnTheBoard: {
          na: false,
          fileUrl: '',
          validation: 0,
          AssessorRemark: '',
          clientRemark: '',
          frequency: '',
          DueDate: '',
          qId: 35,

        },
           BoardDiversity: {
          na: false,
          fileUrl: '',
          validation: 0,
          AssessorRemark: '',
          clientRemark: '',
          frequency: '',
          DueDate: '',
          qId: 36,

        },
           TotalEmployeeCompensationAndBenefits: {
          na: false,
          fileUrl: '',
          validation: 0,
          AssessorRemark: '',
          clientRemark: '',
          frequency: '',
          DueDate: '',
          qId: 37,

        },
           TotalExpenditureOnEmployeeTraining: {
          na: false,
          fileUrl: '',
          validation: 0,
          AssessorRemark: '',
          clientRemark: '',
          frequency: '',
          DueDate: '',
          qId: 38,

        },
           CapexOnEmployeeWelfareInitiatives: {
          na: false,
          fileUrl: '',
          validation: 0,
          AssessorRemark: '',
          clientRemark: '',
          frequency: '',
          DueDate: '',
          qId: 39,

        },
         AnnualReturnsPOSHAct2013: {
          na: false,
          fileUrl: '',
          validation: 0,
          AssessorRemark: '',
          clientRemark: '',
          frequency: '',
          DueDate: '',
          qId: 40,

        },
         PendingCasesPOSHAct2013: {
          na: false,
          fileUrl: '',
          validation: 0,
          AssessorRemark: '',
          clientRemark: '',
          frequency: '',
          DueDate: '',
          qId: 41,

        },
         AccidentReportSubmission: {
          na: false,
          fileUrl: '',
          validation: 0,
          AssessorRemark: '',
          clientRemark: '',
          frequency: '',
          DueDate: '',
          qId: 42,

        },
        PendingNoticeFromGovtBodies: {
          na: false,
          fileUrl: '',
          validation: 0,
          AssessorRemark: '',
          clientRemark: '',
          frequency: '',
          DueDate: '',
          qId: 43,

        },

         NetZeroTarget: {
          na: false,
          fileUrl: '',
          validation: 0,
          AssessorRemark: '',
          clientRemark: '',
          frequency: '',
          DueDate: '',
          qId: 44,

        },
         WomenInWorkforce: {
          na: false,
          fileUrl: '',
          validation: 0,
          AssessorRemark: '',
          clientRemark: '',
          frequency: '',
          DueDate: '',
          qId: 45,

        },
         NumberOfWomenDirectorsOnTheoard: {
          na: false,
          fileUrl: '',
          validation: 0,
          AssessorRemark: '',
          clientRemark: '',
          frequency: '',
          DueDate: '',
          qId: 46,

        },
         ShareholdersCompliantsResolved: {
          na: false,
          fileUrl: '',
          validation: 0,
          AssessorRemark: '',
          clientRemark: '',
          frequency: '',
          DueDate: '',
          qId: 47,

        },
         WhistleblowerComplaintsResolved: {
          na: false,
          fileUrl: '',
          validation: 0,
          AssessorRemark: '',
          clientRemark: '',
          frequency: '',
          DueDate: '',
          qId: 48,

        },
         TotalRecordableIncidentRate: {
          na: false,
          fileUrl: '',
          validation: 0,
          AssessorRemark: '',
          clientRemark: '',
          frequency: '',
          DueDate: '',
          qId: 49,

        },
         AnnualGeneralBodyMeeting: {
          na: false,
          fileUrl: '',
          validation: 0,
          AssessorRemark: '',
          clientRemark: '',
          frequency: '',
          DueDate: '',
          qId: 50,

        },
         BoardMeetings: {
          na: false,
          fileUrl: '',
          validation: 0,
          AssessorRemark: '',
          clientRemark: '',
          frequency: '',
          DueDate: '',
          qId: 51,

        },
         ReviewByAuditCommittee: {
          na: false,
          fileUrl: '',
          validation: 0,
          AssessorRemark: '',
          clientRemark: '',
          frequency: '',
          DueDate: '',
          qId: 52,

        },
         PercentageOfEmployeessignedCOBEC: {
          na: false,
          fileUrl: '',
          validation: 0,
          AssessorRemark: '',
          clientRemark: '',
          frequency: '',
          DueDate: '',
          qId: 53,

        },
         BoardReviewOfESGPerformance: {
          na: false,
          fileUrl: '',
          validation: 0,
          AssessorRemark: '',
          clientRemark: '',
          frequency: '',
          DueDate: '',
          qId: 54,

        },

         CSRProjectsCompletedAndOngoing: {
          na: false,
          fileUrl: '',
          validation: 0,
          AssessorRemark: '',
          clientRemark: '',
          frequency: '',
          DueDate: '',
          qId: 55,

        },
         ReviewByRiskCommittee: {
          na: false,
          fileUrl: '',
          validation: 0,
          AssessorRemark: '',
          clientRemark: '',
          frequency: '',
          DueDate: '',
          qId: 55,

        },
        

        


      }
      try {
        const response = await api.client.createEstablishmentMonthlyData(Monthlydata)
        if (response.status === 201) {
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message);
          setSelectedValues((prevState) => ({
            ...prevState,
            [Monthlydata.establishmentId]: {
              ...prevState[Monthlydata.establishmentId],
              selectedMonth: '',
              selectedYear: '',
            },
          }));
          setSelectedMonth('')
          setSelectYearForMasterData('')

        }
        else if (response.status === 404) {
          setErrorSnackbarOpen(true);
          setSnackbarErrorMessage(response.data.message);
          setSelectedMonth('')
          setSelectYearForMasterData('')
        }

        else if (response.status === 400) {
          setErrorSnackbarOpen(true);
          setSnackbarErrorMessage(response.data.message);
          setSelectedMonth('')
          setSelectYearForMasterData('')
        }
        else if (response.status === 500) {
          setErrorSnackbarOpen(true);
          setSnackbarErrorMessage(response.data.message);
          setSelectedMonth('')
          setSelectYearForMasterData('')
        }
        else {
          setErrorSnackbarOpen(true);
          setSnackbarErrorMessage("Some error occured please try again");
          setSelectedMonth('')
          setSelectYearForMasterData('')
        }



      }
      catch (error) {
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage("Error creating MonthlyData");
      }
    }
  }








  const handleMonthChange = (e) => {
    setSelectedMonth(e.target.value)
  };








  return (
    <div className="m-3">
      <Snackbar
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',

        }}
        severity="success"
        open={snackbarOpen}
        autoHideDuration={2000}
        onClose={() => setSnackbarOpen(false)}
        sx={{
          marginTop: '2.9%',
          marginRight: '7%'
        }}
      >
        <SnackbarContent style={{ backgroundColor: "green" }} message={snackbarMessage} />
      </Snackbar>
      <Snackbar
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        severity="error"
        open={errorSnackbarOpen}
        autoHideDuration={2000}
        sx={{
          marginTop: '2.9%',
          marginRight: '7%'
        }}
        onClose={() => { setErrorSnackbarOpen(false) }}
      >
        <SnackbarContent style={{ backgroundColor: "red" }} message={snackbarErrorMessage} />
      </Snackbar>

      {loading ? (
        <div className="d-flex flex-row align-items-center justify-content-center" style={{ marginTop: '80px' }}>
          <h3>Loading</h3>
          <div className="spinner-grow text-danger" style={{ width: '1rem', height: '1rem', marginLeft: '10px' }} role="status"></div>
          <div className="spinner-grow text-danger" style={{ width: '1rem', height: '1rem', marginLeft: '10px' }} role="status"></div>
          <div className="spinner-grow text-danger" style={{ width: '1rem', height: '1rem', marginLeft: '10px' }} role="status"></div>

        </div>
      ) :
        establishment ? (
          <>


            <TableContainer className="mt-4" component={Paper} >
              <div style={{ width: "100%", overflowY: "auto", overflowX: "auto" }}>
                <table className='border-top-0' >
                  <thead className="position-sticky top-0 " style={{ zIndex: 1000, backgroundColor: "black", borderTop: "none" }} >
                    <tr>
                      {/* <th style={{ color: 'black', fontWeight: "bold", letterSpacing: '0.5px' }}>Client Details</th> */}
                      <th className="text-center border-top-0" style={{ color: 'white', fontWeight: "bold", letterSpacing: '0.5px' }}>Establishment Company Details</th>
                      <th className="text-center border-top-0" style={{ color: 'white', fontWeight: "bold", letterSpacing: '0.5px' }}>Contact-Person Details</th>

                      <th className="text-center border-top-0" style={{ color: 'white', fontWeight: "bold", letterSpacing: '0.5px' }}>Principal Employer Details</th>
                      {/* <th className="text-center" style={{color:'white',fontWeight:"bold",letterSpacing:'0.5px'}}>Contract</th> */}
                      <th className="text-center border-top-0" style={{ color: 'white', fontWeight: "bold", letterSpacing: '0.5px' }}>Status</th>
                      <th className="text-center border-top-0" style={{ color: 'white', fontWeight: "bold", letterSpacing: '0.5px' }}>Actions</th>
                    </tr>
                  </thead>
                  <TableBody>

                    <TableRow>

                      <TableCell><span style={{ fontWeight: 'bold', fontSize: '16px' }}>{establishment.clientName}</span> <br></br>{establishment.clientAddress}<br></br> Contract : {establishment.startDate ? establishment.startDate.slice(0, 10).split('-').reverse().join('-') : ''} to {establishment.endDate ? establishment.endDate.slice(0, 10).split('-').reverse().join('-') : ''}</TableCell>
                      <TableCell>{establishment.clientContactPersonName} <br></br>{establishment.clientContactPersonPhoneNumber}
                        {establishment.clientContactPersonPhoneNumber1 && `, ${establishment.clientContactPersonPhoneNumber1}`}<br></br>{establishment.clientContactPersonEmailId} {establishment.clientContactPersonEmailId1 && ` ,${establishment.clientContactPersonEmailId1}`}
                      </TableCell>

                      <TableCell><span style={{ fontWeight: 'bold', fontSize: '16px' }}>{establishment.principleEmployer}</span><br></br>{establishment.companyAddress}, {establishment.placeName} {establishment.stateId}- {establishment.pinCode}<br></br>{establishment.authorisedPersonName} {establishment.companyPhoneNumber} {establishment.companyPhoneNumber1 && `, ${establishment.companyPhoneNumber1}`}<br></br>{establishment.companyEmailId} {establishment.companyEmailId1 && ` ,${establishment.companyEmailId1}`}</TableCell>
                      <TableCell>
                        {/* {establishmentChartData[establishment.establishmentId] && establishmentChartData[establishment.establishmentId].acceptPercentage !== undefined && (
                        <Pie data={getChartData(establishment.establishmentId)} options={options} />
                      )} */}




                        <>
                          <div className="d-flex">
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                backgroundColor: COLORS.success, // Green for accepted
                                border: '1px solid lightgray',
                                padding: '2px'
                              }}
                            >
                              <Typography sx={{ color: 'black', fontSize: '12px' }}>Accepted </Typography>
                            </Box>

                            <Typography sx={{ color: 'black', fontSize: '14px', paddingLeft: '2px' }}>{establishmentChartData?.AcceptedPercent}%</Typography>

                          </div>


                          <div className="mt-2 mb-2 d-flex">
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                backgroundColor: COLORS.danger, // Green for accepted
                                border: '1px solid lightgray',
                                padding: '2px'
                              }}
                            >
                              <Typography sx={{ color: 'black', fontSize: '12px' }}>Rejected </Typography>
                            </Box>
                            <Typography sx={{ color: 'black', fontSize: '14px', paddingLeft: '2px' }}>{establishmentChartData?.RejectedPercent}%</Typography>

                          </div>



                          <div className="d-flex">
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                backgroundColor: '#B2B2B2', // Green for accepted
                                border: '1px solid lightgray',
                                padding: '2px'

                              }}
                            >
                              <Typography sx={{ color: 'black', fontSize: '12px' }}>Under Review </Typography>
                            </Box>
                            <Typography sx={{ color: 'black', fontSize: '14px', paddingLeft: '2px' }}>{establishmentChartData?.UnderReviewPercent}%</Typography>

                          </div>


                        </>

                      </TableCell>






















                      <TableCell>

                        <>
                          <p className="text-center "><span className="text-danger">Note :</span> Create button will be enabled only if Accepted percentage is above 50%</p>
                          <div style={{ display: 'flex', justifyContent: 'center' }}>


                          </div>
                          <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '10px' }}>

                            <>
                              <select
                                className="mx-2 p-1"
                                style={{ borderRadius: '4px', border: '1px solid lightgray', cursor: 'pointer' }}
                                value={selectedMonth || ''}
                                onChange={(e) => handleMonthChange(e)}

                              >
                                <option value="" disabled>Select Month</option>
                                {months.map((month) => (
                                  <option key={month.value} value={month.value}>
                                    {month.name}
                                  </option>
                                ))}
                              </select>

                              <select className="p-1" style={{ border: '1px solid black', borderRadius: '4px', cursor: 'pointer' }} value={selectYearForMasterData} onChange={handleYearChangeForMasterData} >
                                <option value="" disabled>Select Year</option>
                                {years.map((year) => (
                                  <option key={year} value={year}>
                                    {year}
                                  </option>
                                ))}
                              </select>



                            </>
                            <button className=" mx-1 btn btn-sm btn-success" disabled={establishmentChartData?.AcceptedPercent < 50} onClick={() => handleMonthlyData(companyId, establishment.CorporateId, selectedMonth, selectYearForMasterData)}>Create</button>
                          </div>
                        </>
                      </TableCell>

                    </TableRow>

                  </TableBody>
                </table>
              </div>
            </TableContainer>
          </>
        ) : (
          <div style={{ marginTop: "60px" }}>
            <p className="text-center">No establishment Found !! <Link to="/createestablishment" className="text-danger">Click here</Link> to Create</p>
          </div>
        )}


    </div>
  );
};
